// src/api/activity.api.js
import axiosInstance from './axiosInstance';

export const getActivityLog = (params = {}) =>
  axiosInstance.get('/activity-log/', { params });
